import React, { Component } from 'react'
import YouTube from 'react-youtube';
import {
  Play,
  Pause,
  ExternalLink,
  ChevronsLeft,
  ChevronsRight,
  Volume2,
  VolumeX
} from 'react-feather'
import {
  Container,
  PlayerBar,
  Progress,
  TimeElapsed,
  Duration,
  Controls
} from './styles'

class Video extends Component {
  constructor(props) {
    super(props)

    this.state = {
      videoId: this.props.videoId,
      player: null,
      clip: {
        playing: false,
        muted: false,
        duration: 0,
        currentTime: 0,
        elapsed: 0,
      },
    }

    this.onReady = this.onReady.bind(this)
    this.onPlay = this.onPlay.bind(this)
    this.onMute= this.onMute.bind(this)
    this.moveTime = this.moveTime.bind(this)
    this.getTimeElapsed = this.getTimeElapsed.bind(this)
  }

  onReady (event) {
    this.setState({
      ...this.state,
      player: event.target,
      clip: {
        ...this.state.clip,
        duration: event.target.getDuration()
      }
    })
    //this.getDuration()
  }

  getTimeElapsed() {
    let { player, clip } = this.state
    if (player !== null && clip.playing && player.getCurrentTime() < clip.duration) {
      let elapsed = ((player.getCurrentTime()) / clip.duration) * 100
      this.setState({
        clip: {
          ...clip,
          elapsed: elapsed
        }
      })
    }
  }

  moveTime(forward = true, duration = 10) {
    if (this.state.player !== null) {
      let currentTime = this.state.player.getCurrentTime()
      if (forward) {
        currentTime = currentTime + duration
      } else if (!forward && currentTime > 0) {
        currentTime = currentTime - duration
      } else {
        currentTime = 0
      }
      this.state.player.seekTo(currentTime)
    }
  }

  onPlay() {
    if (this.state.player !== null && !this.state.clip.playing) {
      this.state.player.playVideo()
      this.setState({
        clip: {
          ...this.state.clip,
          playing: true
        }
      })
    } else {
      this.state.player.pauseVideo()
      this.setState({
        clip: {
          ...this.state.clip,
          playing: false
        }
      })
    }
  }

  onMute = () => {
    if (this.state.player !== null && !this.state.clip.muted) {
      this.state.player.mute()
      this.setState({
        clip: {
          ...this.state.clip,
          muted: true
        }
      })
    } else {
      this.state.player.unMute()
      this.setState({
        clip: {
          ...this.state.clip,
          muted: false
        }
      })
    }
  }

  componentDidMount() {
    this.timerID = setInterval(
      () => this.getTimeElapsed(),
      1000
    )
  }

  componentWillUnmount() {
    clearInterval(this.timerID)
  }

  render() {
    // Defines iconsize of the controls.
    const iconSize = "30"

    // Options for Youtube.
    const opts = {
      height: '310',
      width: '100%',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 0,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
      }
    }

    const play = !this.state.clip.playing ? (
      <Play size={iconSize} />
    ) : (
      <Pause size={iconSize} />
    )

    const mute = this.state.clip.muted ? (
      <VolumeX size={iconSize} />
    ) : (
      <Volume2 size={iconSize} />
    )

    return(
      <Container>
        <YouTube
          videoId={this.state.videoId}
          onReady={this.onReady}
          onPlay={() => {
            this.setState({
              clip: {
                ...this.state.clip,
                playing: true
              }
            })
          }}
          onPause={() => {
            this.setState({
              clip: {
                ...this.state.clip,
                playing: false
              }
            })
          }}
          opts={opts}
        />

        <PlayerBar>
          <Progress>
            <TimeElapsed elapsed={this.state.clip.elapsed}/>
            <Duration/>
          </Progress>

          <Controls>
            <a
              href={`https://www.youtube.com/watch?v=${this.state.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
              ><ExternalLink size={iconSize}/></a>
            <ChevronsLeft size={iconSize} onClick={() => this.moveTime(false)}/>
            <div onClick={() => this.onPlay()}>
              {play}
            </div>
            <ChevronsRight size={iconSize} onClick={() => this.moveTime()}/>
            <div onClick={() => this.onMute()}>
              {mute}
            </div>
          </Controls>
        </PlayerBar>

      </Container>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/Components/Video/index.js